import { Community, Lot, ScheduleTask, ScheduleVendorAcctCategoryAssoc } from "./index";
import { JobPlanOption } from "./jobplanoption";
import { Plan } from "./plan";

export class Job {
    public id: number;
    public financialCommunityId: number;
    public community: Community;
    public jobTypeName: string;
    public lotId: number;
    public lot: Lot;
    public lotBlock: string;
    public streetAddress1: string;
    public streetAddress2: string;
    public handing: string;
    public planId: number;
    public plan: Plan;
    public elevation: string;
    public constructionStageName: string;
    public constructionStageStartDate: Date;
    public jobScheduleStatusName: string;
    public startDate: Date;
    public jioApprovedDate: Date;
    public projectedFinalDate: Date;
    public baselineFinishDate: Date;
    public permitNumber: string;
    public templateId: number;
    public scheduleTasks: ScheduleTask[];
    public scheduleVendorAcctCategoryAssocs: ScheduleVendorAcctCategoryAssoc[];
    public todayUtcDate: Date;
    public jobPlanOptions: JobPlanOption[];
}
